import fetch from 'isomorphic-fetch';
import { each } from 'lodash';

function getPlaylistLink( action ) {
  var formData = new FormData();
  formData.append('action', action.action);
  formData.append('create_playlist_link_nonce', window.HIFI_APP.create_playlist_link_nonce);
  formData.append('playlist[id]', action.playlist.id);

  let trackCount = 0;
  each(action.playlist.tracks, (track, trackKey) => {
    const prefix = 'playlist[songs][' + trackCount + ']';
    formData.append(prefix + '[id]', track.trackId);
    formData.append(prefix + '[versionId]', track.versionId);
    trackCount++;
  });

  return fetch(window.HIFI_APP.ajax_url, {
    method: 'POST',
    body: formData,
  })
    .then(response => response.json())
    .then(json => json.link);
}

export {
  getPlaylistLink,
};